import { WorkerOnboardingsContainer } from './WorkerOnboardingsContainer';

const name = 'WorkerOnboardingsContainer';

export { WorkerOnboardingsContainer, name };
